import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  label: { color: '#C5203F' },
}));
